import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { environment } from '../env';
interface Skill {
  id?: number;
  name: string;
  category: {
    id: number;
    name: string;
  };
  userId: number;
}

// Define API slice
export const skillApi = createApi({
  reducerPath: 'skillApi',
  baseQuery: fetchBaseQuery({
    baseUrl: environment.apiUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Skill'],
  endpoints: (builder) => ({
    getSkillsByUserId: builder.query<Skill[], number>({
      query: (userId) => `/skills/${userId}`,
      providesTags: ['Skill']
    }),

    addSkill: builder.mutation<Skill, { name: string; categoryId: number; userId: number }>({
      query: (newSkill) => ({
        url: `/skills`,
        method: 'POST',
        body: newSkill,
      }),
      invalidatesTags: ['Skill']
    }),

    updateSkill: builder.mutation<Skill, { id?: number; name?: string; categoryId?: number }>({
      query: ({ id, ...rest }) => ({
        url: `/skills/${id}`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: ['Skill']
    }),

    deleteSkill: builder.mutation<void, number>({
      query: (skillId) => ({
        url: `/skills/${skillId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Skill']
    }),    
  }),
});

export const {
  useGetSkillsByUserIdQuery,
  useAddSkillMutation,
  useUpdateSkillMutation,
  useDeleteSkillMutation,
} = skillApi;
